import { AfterContentChecked, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { EstimateSettingsService } from '@shared/services/estimate-settings.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'pop-app-container',
  templateUrl: './app-container.component.html',
  styleUrls: ['./app-container.component.less']
})
export class AppContainerComponent implements AfterContentChecked, OnInit {
  public showSideMenu = false;
  private isLicenseExpiringSoon: boolean;
  public overlay: boolean;
  private reminder = true;

  public constructor(
    private translateService: TranslateService,
    private confirmationService: ConfirmationService,
    private settingsService: EstimateSettingsService,
    public dialog: MatDialog
  ) {}

  public async ngOnInit() {
    this.showSideMenu = await this.settingsService.getRestrictEstimateListAccess();
  }

  public ngAfterContentChecked() {
    if (this.reminder) {
      if (this.isLicenseExpiringSoon) {
        this.licenseReminderMessage();
      }
    }
  }

  private licenseReminderMessage() {
    this.overlay = true;
    this.confirmationService.confirm({
      //TO-DO add amount of days remaining
      closeOnEscape: true,
      dismissableMask: true,
      message: `${this.translateService.instant('ERROR.LICENSE_EXPIRING') as string} X ${
        this.translateService.instant('MODAL.DAYS') as string
      }.`,
      header: this.translateService.instant('OPTIONS.LICENSES') as string,
      icon: 'fas fa-exclamation-triangle',
      key: 'global-confirmation-dialog',
      acceptLabel: this.translateService.instant('BUTTON.OK') as string,
      rejectLabel: this.translateService.instant('BUTTON.CANCEL') as string,
      accept: () => {
        this.overlay = false;
        this.reminder = false;
      },
      reject: () => {}
    });
  }
}
